import { ASSETS_ADD_JS, ASSETS_ADD_CSS } from 'actions/assets';

const DEFAULT_STATE = {
  js: [],
  css: []
};

const isDupe = (newEntry, entries) =>
  entries.some(entry => entry.uri === newEntry.uri);

export default function assets(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case ASSETS_ADD_JS: {
      const js = isDupe(action, state.js)
        ? state.js
        : [...state.js, { parentTag: action.parentTag, uri: action.uri }];
      return { ...state, js };
    }
    case ASSETS_ADD_CSS: {
      const css = isDupe(action, state.css)
        ? state.css
        : [...state.css, { parentTag: action.parentTag, uri: action.uri }];
      return { ...state, css };
    }
    default:
      return state;
  }
}
